import React from "react";

import { SimpleLinkWithSubtextBlock as Value } from "@reactivated";

import { Clickable } from "../Clickables";

import styles from "./FooterCta.module.scss";

interface Props {
    value: Value;
}

export const FooterCtaBlock = ({ value: cta }: Props) => {
    if (!cta.url) return <></>;
    if (!cta.display_name && !cta.subtitle) return <></>;

    return (
        <div className={styles.ctaBlock}>
            <Clickable icon="arrow" className={styles.cta} href={cta.url}>
                {cta.display_name && (
                    <span className={styles.title}>{cta.display_name}</span>
                )}
                {cta.subtitle && (
                    <span className={styles.subtitle}>{cta.subtitle}</span>
                )}
            </Clickable>
        </div>
    );
};
